import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const painPoints = ['Le das balanceado todos los días sin saber qué tiene realmente adentro  y en el fondo sentís que le estás fallando', 'Lo ves sin energía, con el pelo raro, con la panza hinchada, se rasca, se lame y te preguntás si es tu culpa sin animarte a confirmarlo', 'Querés empezar a darle comida natural pero tenés miedo de hacerlo mal y terminar lastimándolo sin querer', 'Buscaste información y cada cosa que leíste te contradijo la anterior y no sabés en quién confiar ni por dónde empezar', 'Sentís que otras dueñas ya saben cómo cuidar mejor a sus perros y vos todavía no encontraste cómo empezar'];
export function ProblemSection() {
  return <section className="py-12 md:py-16 px-4 bg-lightgreen" data-id="element-190">
      <div className="max-w-2xl mx-auto" data-id="element-191">
        {/* Inner card container */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white/80 backdrop-blur-sm rounded-3xl border border-sage/60 shadow-[0_4px_32px_rgba(0,0,0,0.06)] px-5 py-7 md:px-8 md:py-9" data-id="element-192">
          {/* Title */}
          <div className="text-center mb-6" data-id="element-193">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent/10 mb-3" data-id="element-194">
              <AlertTriangleIcon className="w-5 h-5 text-accent" data-id="element-195" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif text-charcoal leading-tight mb-2" data-id="element-196">
              Tu perro podría estar{' '}
              <span className="text-primary text-[1.15em] font-extrabold uppercase tracking-wide" data-id="element-197">
                enfermando
              </span>
              <br data-id="element-198" />
              por lo que come...
            </h2>
            <p className="text-lg md:text-xl font-semibold text-accent" data-id="element-199">
              Y tú ni siquiera lo sabés
            </p>
            <div className="w-16 h-1 bg-accent mx-auto rounded-full mt-3" data-id="element-200"></div>
          </div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="text-center text-xl md:text-2xl font-bold text-charcoal mb-6" data-id="element-201">
            En el fondo sabés que…
          </motion.p>

          {/* Pain Point Cards */}
          <div className="flex flex-col gap-3 mb-7" data-id="element-202">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: 0.15 + index * 0.08
          }} className="flex items-start gap-3 bg-[#FFF0F0] rounded-xl px-4 py-3.5" data-id="element-203">
                <span className="text-[#E05555] text-lg flex-shrink-0 mt-0.5" data-id="element-204">
                  ❌
                </span>
                <span className="text-sm md:text-base text-gray-700 leading-snug" data-id="element-205">
                  {point}
                </span>
              </motion.div>)}
          </div>

          {/* Closing Message */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="rounded-2xl border border-primary/20 px-5 py-5 md:px-6 md:py-6 max-w-xl mx-auto text-center bg-[#F8F6F3]" data-id="element-206">
            <p className="text-xl md:text-2xl font-extrabold text-primary leading-snug" data-id="element-207">
              No sos mala dueña.
              <br data-id="element-208" />
              <span className="text-gray-600 font-semibold" data-id="element-209">
                Solo nadie te enseñó cómo hacerlo bien.
              </span>
              <br data-id="element-210" />
              <span className="text-accent text-[1.1em] font-black uppercase tracking-wide" data-id="element-211">
                Hasta hoy.
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}